import React from 'react'
import PropTypes from 'prop-types'

function Triangle({ className }) {
  return (
    <svg viewBox="0 0 32 32" className={className}>
      <svg>
        <path fillRule="evenodd" d="M4 6L0 0h8z" />
      </svg>
    </svg>
  )
}

Triangle.propTypes = {
  className: PropTypes.string.isRequired
}

export default Triangle
